/**
 * New Relic `environment` facet. Uses the value from runtime `config.js`
 * (copied per deploy from `config/config.{env}.js`), not the hostname.
 */
export function isLocalNewRelicEnvironment({
  dev,
  appMode,
  newrelicLocal,
}: {
  dev: boolean;
  appMode: string | undefined;
  newrelicLocal: boolean;
}): boolean {
  return newrelicLocal || dev || appMode === "local";
}

export function resolveNewRelicEnvironment({
  configured,
  local,
}: {
  configured: string | undefined;
  local: boolean;
}): string {
  if (local) {
    return "local";
  }

  const environment = configured?.trim();
  if (environment !== undefined && environment.length > 0) {
    return environment;
  }

  return "unknown";
}
